import { appMethod as app } from '@utils/app';

import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './MemberDayDetail.less';

export default class MemberDayDetail extends OfficialPage {
  state = {
    memberDayInfo: {}, // 会员日信息
    weekData: [
      { label: '周一', value: 1 },
      { label: '周二', value: 2 },
      { label: '周三', value: 3 },
      { label: '周四', value: 4 },
      { label: '周五', value: 5 },
      { label: '周六', value: 6 },
      { label: '周日', value: 7 }
    ],
    franchiseeId: ''
  }

  constructor(props) {
    super(props);
    document.title = '会员日详情';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    let id = options.id ? options.id : ''
    let franchiseeId = options.franchisee || ''
    this.setData({
      franchiseeId: franchiseeId
    })
    this.getMemberDetail(id)
  }

  getMemberDetail = id => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=appVipCard/getVipBenefitDay',
      method: 'post',
      data: {
        data_id: id,
        sub_shop_app_id: _this.data.franchiseeId
      },
      hideLoading: true,
      success: function(res) {
        let data = res.data
        if (data.date_type === '0') {
          if (data.start_date === data.end_date) {
            data.date = data.start_date
          } else {
            data.date = data.start_date + ' 至 ' + data.end_date
          }
        } else if (data.date_type === '1') {
          let len = data.date_arr.length
          data.date = ''
          data.date_arr.forEach((date, ind) => {
            ind === len - 1
              ? (data.date += _this.data.weekData[date - 1]['label'])
              : (data.date += _this.data.weekData[date - 1]['label'] + '、')
          })
        } else if (data.date_type === '2') {
          let len = data.date_arr.length
          data.date = '每月'
          data.date_arr.forEach((date, ind) => {
            ind === len - 1
              ? (data.date += date + '号')
              : (data.date += date + '号、')
          })
        }
        data.benefits = []
        if (data.discount && data.discount != 0) {
          data.benefits.push({
            category: 'discount',
            discount: data.discount
          })
        }
        if (
          data.user_coupon_list &&
          Array.isArray(data.user_coupon_list) &&
          data.user_coupon_list.length
        ) {
          data.user_coupon_list.map(coupon => {
            coupon.category = 'coupon'
            coupon.name =
              coupon.type === '0'
                ? '满减券'
                : coupon.type === '1'
                ? '打折券'
                : coupon.type === '2'
                  ? '代金券'
                  : coupon.type === '3'
                    ? '兑换券'
                    : coupon.type === '4'
                      ? '储值券'
                      : coupon.type === '5'
                        ? '通用券'
                        : ''
            data.benefits.push(coupon)
          })
        }
        _this.setData({
          memberDayInfo: res.data
        })
        console.log(_this.data.memberDayInfo)
      }
    })
  }

  render() {
    const { memberDayInfo } = this.state
    return (
      <div className="official-page member-day-detail">
        <TopNav title="会员日详情"/>
        <div className="content">
          <div className="info-item space-between">
            <div className="name">名称</div>
            <div className="right-block">{memberDayInfo.title}</div>
          </div>
          <div className="info-item space-between">
            <div className="name">日期</div>
            <div className="right-block">{memberDayInfo.date}</div>
          </div>
          <div className="info-item space-between">
            <div className="name">时间段</div>
            <div className="right-block">
              {memberDayInfo.start_time + ' - ' + memberDayInfo.end_time}
            </div>
          </div>
          <div className="info-item space-between">
            <div className="name">可领取用户</div>
            {memberDayInfo.user_condition === '0' ? (
              <div className="right-block">所有用户</div>
            ) : memberDayInfo.user_condition === '1' ? (
              <div className="right-block">所有会员</div>
            ) : (
              <div className="right-block">
                {Array.isArray(memberDayInfo.user_condition_list) && memberDayInfo.user_condition_list.map((item, idx) => {
                  return (
                    <div key={idx}>
                      {idx === memberDayInfo.user_condition_list.length - 1
                        ? item
                        : item + '、'}
                    </div>
                  )
                })}
              </div>
            )}
          </div>
          {memberDayInfo.benefits && memberDayInfo.benefits.length && (
            <div className="info-item">
              <div className="name">基本权益</div>
              <div className="about-block">
                {memberDayInfo.benefits.map((item, idx) => {
                  return (
                    <div className="about-item" key={idx}>
                      {item.category === 'discount'
                        ? idx +
                        1 +
                        '.所有商品打' +
                        item.discount +
                        '折；（仅会员日活动期间有效）'
                        : item.category === 'coupon'
                          ? idx + 1 + '.' + item.name + '-' + item.title
                          : ''}
                    </div>
                  )
                })}
              </div>
            </div>
          )}
          {memberDayInfo.description !== '' && (
            <div className="info-item">
              <div className="name">商家留言</div>
              <div className="about-block">
                <div className="about-item">{memberDayInfo.description}</div>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/member-day-detail/MemberDayDetail.jsx